import { render, staticRenderFns } from "./MiniFooter.vue?vue&type=template&id=c2fb671a&"
import script from "./MiniFooter.vue?vue&type=script&lang=ts&"
export * from "./MiniFooter.vue?vue&type=script&lang=ts&"
import style0 from "./MiniFooter.vue?vue&type=style&index=0&id=c2fb671a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports